import { render, staticRenderFns } from "./PagesSegmentationNav.vue?vue&type=template&id=a1aa90be&scoped=true&"
import script from "./PagesSegmentationNav.vue?vue&type=script&lang=js&"
export * from "./PagesSegmentationNav.vue?vue&type=script&lang=js&"
import style0 from "./PagesSegmentationNav.vue?vue&type=style&index=0&id=a1aa90be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aa90be",
  null
  
)

export default component.exports